const apiUrl = localStorage.getItem('apiUrl');
const apiTimeout = localStorage.getItem('apiTimeout')
  ? parseInt(localStorage.getItem('apiTimeout'), 10)
  : 40;

const api = apiUrl || process.env.VUE_APP_API_URL;
const baseUrl = process.env.VUE_APP_BASE_URL;
const frontBaseUrl = process.env.VUE_APP_FRONT_BASE_URL;
const reCaptchaSiteKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
const turnstileSiteKey = process.env.VUE_APP_TURNSTILE_SITE_KEY;
const captchaProvider = process.env.VUE_APP_CAPTCHA_PROVIDER || 'recaptcha';

export default {
  api,
  apiTimeout: apiTimeout * 100000,
  baseUrl,
  appTitle: process.env.VUE_APP_MAIN_TITLE,
  frontBaseUrl,
  captcha: {
    provider: captchaProvider,
    reCaptchaSiteKey,
    turnstileSiteKey,
  },
  appSettings: {
    tinyMceConfig: {
      height: '600px',
      content_style: `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');

  body {
    font-family: 'Poppins', Arial, sans-serif;
    font-size: 12pt;   /* ← 10pt → 12pt, jedino ovdje */
    color: #777;
  }

  p, li, td, th {
    font-family: 'Poppins', Arial, sans-serif;
    /* font-size NEMA ovdje — nasljeđuje se od body */
    color: #777;
  }

  h2 {
    font-family: 'Poppins', Arial, sans-serif;
    color: #000;
    font-weight: 700;
  }

  a {
    color: #3598DB !important;
  }
`,
      images_upload_url: api + '/articles/tiny/upload-image',
      images_upload_base_path: baseUrl,
      automatic_uploads: true,
      link_default_target: '_blank',
      license_key: 'gpl',
      font_formats: `Poppins=Poppins,sans-serif;\
    Andale Mono=andale mono,times; \
    Arial=arial,helvetica,sans-serif; \
    Arial Black=arial black,avant garde; \
    Book Antiqua=book antiqua,palatino; \
    Comic Sans MS=comic sans ms,sans-serif; \
    Courier New=courier new,courier; \
    Georgia=georgia,palatino; \
    Helvetica=helvetica; \
    Impact=impact,chicago; \
    Symbol=symbol; \
    Tahoma=tahoma,arial,helvetica,sans-serif; \
    Terminal=terminal,monaco; \
    Times New Roman=times new roman,times; \
    Trebuchet MS=trebuchet ms,geneva; \
    Verdana=verdana,geneva; \
    Webdings=webdings; \
    Wingdings=wingdings,zapf dingbats`,
      font_family_formats: `Poppins=Poppins,sans-serif;\
    Andale Mono=andale mono,times; \
    Arial=arial,helvetica,sans-serif; \
    Arial Black=arial black,avant garde; \
    Book Antiqua=book antiqua,palatino; \
    Comic Sans MS=comic sans ms,sans-serif; \
    Courier New=courier new,courier; \
    Georgia=georgia,palatino; \
    Helvetica=helvetica; \
    Impact=impact,chicago; \
    Symbol=symbol; \
    Tahoma=tahoma,arial,helvetica,sans-serif; \
    Terminal=terminal,monaco; \
    Times New Roman=times new roman,times; \
    Trebuchet MS=trebuchet ms,geneva; \
    Verdana=verdana,geneva; \
    Webdings=webdings; \
    Wingdings=wingdings,zapf dingbats`,
      font_size_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline | alignleft aligncenter alignright | bullist numlist outdent indent | link image media table | code',
      textcolor_map: [
        '000000',
        'Black',
        'FFFFFF',
        'White',
        '808080',
        'Grey',
        '3598DB',
        'Link Blue',
      ],
      plugins: `advlist autolink lists link image charmap preview anchor pagebreak
    searchreplace wordcount visualblocks visualchars code fullscreen
    insertdatetime media nonbreaking save table directionality
    emoticons`,
    },

    mediaLibrary: {
      url: `${api}/media-library/update-media-library`,
      thumbnailWidth: 200,
      destroyDropzone: true,
      acceptedFiles: 'image/*, application/pdf',
    },
  },
};
